import React from "react";
import TestsPageTemplate from "../components/TestsPageTemplate";
import {TEST_TYPES} from "../../../../shared/types/testTypes";

const TestsScientificLiteracy = () => {

    return (
        <TestsPageTemplate
            config={TEST_TYPES.scientificLiteracy}
        />
    );
};

export default TestsScientificLiteracy;
